<template>
    <ThText
        :size="data.textSize"
        :color
        :alignment="data.alignment"
    >
        <!-- eslint-disable-next-line vue/no-v-html-->
        <div v-html="localizeHrefs(data.text)"></div>
    </ThText>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { Color, ComponentTextFragment } from '@/graphql/api'
import { getColorForBackground } from '@/components/ui/buttons'
import { cmsColorToButtonColor } from '@/components/cms'
import { useHrefLocalizer } from '@/router/href-localizer'

import ThText from '@/components/ui/ThText.vue'

const { background = undefined } = defineProps<{
    data: ComponentTextFragment
    background?: Color
}>()

const localizeHrefs = useHrefLocalizer()

const color = computed(
    () => background && getColorForBackground(cmsColorToButtonColor(background))
)
</script>
